import {
    DriveEta, Facebook, Instagram, LinkedIn, PhoneAndroid
} from "@material-ui/icons"
import React from "react"

const FooterListIcon = iconType => {
    let icon

    switch (iconType) {
        case "contacts":
            // icon = <ContactPhone />;
            break
        case "shoppingcart":
            // icon = <Contacts />;
            break
        case "vehicle":
            icon = <DriveEta />
            break
        case "device":
            icon = <PhoneAndroid />
            break
        case "mail":
            // icon = <Mail />;
            break
        case "info":
            // icon = <Info />;
            break
        case "facebook":
            icon = <Facebook style={{ color: "blue" }} />
            break
        case "instagram":
            icon = <Instagram style={{ color: "#f09433" }} />
            break
        case "linkedin":
            icon = <LinkedIn style={{ color: "#0072b1" }} />
            break
        case "files":
            break
        case "search":
            // icon = <Search />;
            break
        case "history":
            // icon = <HistoryOutlined />;
            break
        case "movie":
            // icon = <Movie />;
            break
        case "picture":
            // icon = <CameraAlt />;
            break
        case "map":
            // icon = <Room />;
            break
        default:
            icon = undefined
    }
    return icon
}

export default FooterListIcon
